
import React, { useEffect,useState,useRef,useCallback } from 'react';
import {Badge,Tooltip} from 'antd'
import CandtraceModel from '../dashboard/components/candtraceModel';

const StatusColumn = ({ record, valueEnum, islink}) => {
    const textRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const timerRef = useRef(null);
    const [showCandtraceModel, setShowCandtraceModel] = useState(false);

    const checkOverflow = useCallback(() => {
      if (!textRef.current) return;
      
      // 双重检测：立即检测 + 延迟检测
      const check = () => {
        const { scrollWidth, clientWidth } = textRef.current;
        setIsOverflowing(scrollWidth > clientWidth);
      };
  
      check(); // 立即检查
      
      // 防抖后再次检查（应对动态布局）
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(check, 300);
    }, []);
  
    useEffect(() => {
      if (!textRef.current) return;
  
      const observer = new ResizeObserver(checkOverflow);
      observer.observe(textRef.current);
  
      // 初始检查（处理表格异步加载数据的情况）
      const initTimer = setTimeout(checkOverflow, 100);
  
      return () => {
        observer.disconnect();
        clearTimeout(initTimer);
        clearTimeout(timerRef.current);
      };
    }, [checkOverflow]);
  
    // 当数据变化时重新检查
    useEffect(() => {
      checkOverflow();
    }, [record, checkOverflow]);

    const closeModal = () =>{
      setShowCandtraceModel(false);
    }
  
    
    const statusInfo = record.invitation_status ? valueEnum[record.invitation_status] : null;
    const displayText = statusInfo?.text || '';
    var badgeStatus = statusInfo?statusInfo.status:'';
    var badgeColor = statusInfo?statusInfo.color:'';
    if(badgeStatus)
      badgeStatus = badgeStatus.toLowerCase();
    if(badgeColor)
      badgeColor = badgeColor.toLowerCase();
  
    const content = (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {/* <span 
          style={{
            display: 'inline-block',
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: dotColor,
            flexShrink: 0
          }}
        /> */}
        <Badge
          // style={{ maxWidth: 120, display: 'inline-block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
          status={badgeStatus} 
          color={badgeColor} 
          // text={statusObj.text} 
        />
        <span 
          ref={textRef}
          style={{ 
            overflow: 'hidden', 
            textOverflow: 'ellipsis', 
            whiteSpace: 'nowrap',
            flex: 1,
            cursor: islink?"pointer":"text"
          }}
          onClick={()=>{
            if(islink)
              setShowCandtraceModel(true);
          }}
        >
          {displayText}
        </span>
      </div>
    );
    console.log('entries 2- ', isOverflowing, displayText)

    // return <Tooltip title={displayText} overlayClassName="custom-tooltip">
    //     {content}
    //   </Tooltip>
    return (
      <div>
        {isOverflowing ? 
          <Tooltip title={displayText} overlayClassName="custom-tooltip">
            {content}
          </Tooltip>
        : 
        <span>{content}</span>
        }

      <CandtraceModel
        showModal={showCandtraceModel}
        closeModal={closeModal}
        tenant_id={record.tenant_id}
        candidate_id={record.candidate_id}
      />


      </div>
    );
    
  };

  export default StatusColumn